export const mustelidae = [
"Ferret",
"Mink",
"Weasel",
]
